<template>
  <div>
    <div class="modal" @mousedown.self="closePopup" v-if="likeModalShow">
      <div class="modal-dialog modal-dialog-sm">
        <div class="modal-content modal-content-small">
          <div class="feedback-image">
            <img src="./../assets/img/kid/complete-step.svg" width="250" height="250" alt="Configuration complete">
          </div>
          <div v-if="!userLike" class="text-muted text-md mb-1 mt-1">Help us to improve</div>
          <div class="text-center mt-2" v-if="userLike">
            Happy to hear that! Please, give us review on
            <a target="_blank" href="https://chrome.google.com/webstore/detail/browserlock-kids-mode/bpdfgemboafffcebklpmpgelkjgdpgdl">
            chrome store
            </a> <br>
            <a class="btn btn-main mt-1" @click="openStore" target="_blank" href="https://chrome.google.com/webstore/detail/browserlock-kids-mode/bpdfgemboafffcebklpmpgelkjgdpgdl">
            Ok
            </a>
          </div>
          <div class="text-center" v-if="userDisLike">
            Sorry to hear that. <br>Please, give us feedback
            <br>
            <button class="btn btn-main mt-1" @click="openFeedbackForm">
            Ok
            </button>
          </div>
          <div v-if="!userDisLike && !userLike">
            <div class="text-xl mb-1">Did you like our product?</div>
            <div class="flex-between">
              <div class="btn-rating -like" @click="userLiked">
                <div class="btn-rating-icon">
                  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M17.2236 12.2371C17.5925 11.7666 17.7694 11.2622 17.7468 10.7428C17.7242 10.1706 17.4683 9.72271 17.2575 9.44793C17.5022 8.83814 17.5963 7.87829 16.7795 7.133C16.181 6.5872 15.1646 6.34253 13.7569 6.41029C12.7669 6.45546 11.9388 6.6399 11.9049 6.64743H11.9012C11.713 6.6813 11.5135 6.72271 11.3102 6.76788C11.2951 6.52698 11.3365 5.92848 11.7807 4.58093C12.3077 2.97742 12.2776 1.75031 11.6828 0.929736C11.058 0.0677541 10.0605 0 9.7669 0C9.4846 0 9.22487 0.116688 9.04043 0.331242C8.62261 0.816813 8.67155 1.71267 8.72425 2.12673C8.22738 3.45922 6.83466 6.72647 5.65649 7.63363C5.63391 7.64868 5.61509 7.6675 5.59626 7.68632C5.24997 8.05144 5.01659 8.44668 4.8585 8.79297C4.63642 8.67252 4.38422 8.60477 4.1132 8.60477H1.81709C0.951346 8.60477 0.251221 9.30866 0.251221 10.1706V16.2873C0.251221 17.1531 0.95511 17.8532 1.81709 17.8532H4.1132C4.44821 17.8532 4.76063 17.7478 5.01659 17.5671L5.90116 17.6725C6.03667 17.6913 8.4457 17.9962 10.9187 17.9473C11.3667 17.9812 11.7882 18 12.1797 18C12.8535 18 13.4407 17.9473 13.93 17.8419C15.0818 17.5972 15.8685 17.1079 16.2675 16.389C16.5724 15.8394 16.5724 15.2936 16.5235 14.9473C17.2726 14.2698 17.4043 13.5207 17.3779 12.9937C17.3629 12.6888 17.2951 12.4291 17.2236 12.2371ZM1.81709 16.8369C1.5122 16.8369 1.26753 16.5885 1.26753 16.2873V10.1669C1.26753 9.86198 1.51596 9.61731 1.81709 9.61731H4.1132C4.4181 9.61731 4.66276 9.86575 4.66276 10.1669V16.2836C4.66276 16.5885 4.41433 16.8331 4.1132 16.8331H1.81709V16.8369ZM16.26 11.7967C16.1019 11.9624 16.0718 12.2146 16.1923 12.4103C16.1923 12.4141 16.3466 12.6775 16.3654 13.0389C16.3917 13.532 16.1546 13.9686 15.6577 14.3413C15.4808 14.4768 15.4093 14.7102 15.4846 14.921C15.4846 14.9247 15.6465 15.4216 15.383 15.8921C15.1308 16.3438 14.5699 16.6675 13.7192 16.8482C13.0379 16.995 12.1119 17.0213 10.9752 16.931C10.9601 16.931 10.9413 16.931 10.9225 16.931C8.50216 16.9837 6.05549 16.6675 6.02914 16.6637H6.02537L5.6452 16.6186C5.66778 16.5132 5.67908 16.4003 5.67908 16.2873V10.1669C5.67908 10.005 5.65273 9.84693 5.60756 9.70013C5.67531 9.44793 5.86352 8.88708 6.30768 8.40903C7.99777 7.06901 9.65022 2.54831 9.72174 2.35257C9.75185 2.27353 9.75938 2.18695 9.74432 2.10038C9.68033 1.6788 9.70291 1.16311 9.79325 1.00878C9.99275 1.01255 10.531 1.06901 10.8547 1.51694C11.2387 2.04768 11.2236 2.99624 10.8096 4.25345C10.1772 6.16938 10.1245 7.17817 10.6251 7.62233C10.8736 7.84442 11.2048 7.85571 11.4457 7.76913C11.6753 7.71644 11.8936 7.67127 12.1007 7.63739C12.1157 7.63363 12.1345 7.62986 12.1496 7.6261C13.3052 7.3739 15.3754 7.21957 16.0944 7.87453C16.7042 8.43162 16.2713 9.16938 16.2224 9.24843C16.0831 9.45922 16.1245 9.734 16.3127 9.90339C16.3165 9.90715 16.7117 10.2798 16.7305 10.7804C16.7456 11.1154 16.5875 11.458 16.26 11.7967Z" fill="black"/>
                  </svg>
                </div>
                Yes
              </div>
              <div class="btn-rating -dislike" @click="userDisliked">
                <div class="btn-rating-icon">
                  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M17.2236 12.2371C17.5925 11.7666 17.7694 11.2622 17.7468 10.7428C17.7242 10.1706 17.4683 9.72271 17.2575 9.44793C17.5022 8.83814 17.5963 7.87829 16.7795 7.133C16.181 6.5872 15.1646 6.34253 13.7569 6.41029C12.7669 6.45546 11.9388 6.6399 11.9049 6.64743H11.9012C11.713 6.6813 11.5135 6.72271 11.3102 6.76788C11.2951 6.52698 11.3365 5.92848 11.7807 4.58093C12.3077 2.97742 12.2776 1.75031 11.6828 0.929736C11.058 0.0677541 10.0605 0 9.7669 0C9.4846 0 9.22487 0.116688 9.04043 0.331242C8.62261 0.816813 8.67155 1.71267 8.72425 2.12673C8.22738 3.45922 6.83466 6.72647 5.65649 7.63363C5.63391 7.64868 5.61509 7.6675 5.59626 7.68632C5.24997 8.05144 5.01659 8.44668 4.8585 8.79297C4.63642 8.67252 4.38422 8.60477 4.1132 8.60477H1.81709C0.951346 8.60477 0.251221 9.30866 0.251221 10.1706V16.2873C0.251221 17.1531 0.95511 17.8532 1.81709 17.8532H4.1132C4.44821 17.8532 4.76063 17.7478 5.01659 17.5671L5.90116 17.6725C6.03667 17.6913 8.4457 17.9962 10.9187 17.9473C11.3667 17.9812 11.7882 18 12.1797 18C12.8535 18 13.4407 17.9473 13.93 17.8419C15.0818 17.5972 15.8685 17.1079 16.2675 16.389C16.5724 15.8394 16.5724 15.2936 16.5235 14.9473C17.2726 14.2698 17.4043 13.5207 17.3779 12.9937C17.3629 12.6888 17.2951 12.4291 17.2236 12.2371ZM1.81709 16.8369C1.5122 16.8369 1.26753 16.5885 1.26753 16.2873V10.1669C1.26753 9.86198 1.51596 9.61731 1.81709 9.61731H4.1132C4.4181 9.61731 4.66276 9.86575 4.66276 10.1669V16.2836C4.66276 16.5885 4.41433 16.8331 4.1132 16.8331H1.81709V16.8369ZM16.26 11.7967C16.1019 11.9624 16.0718 12.2146 16.1923 12.4103C16.1923 12.4141 16.3466 12.6775 16.3654 13.0389C16.3917 13.532 16.1546 13.9686 15.6577 14.3413C15.4808 14.4768 15.4093 14.7102 15.4846 14.921C15.4846 14.9247 15.6465 15.4216 15.383 15.8921C15.1308 16.3438 14.5699 16.6675 13.7192 16.8482C13.0379 16.995 12.1119 17.0213 10.9752 16.931C10.9601 16.931 10.9413 16.931 10.9225 16.931C8.50216 16.9837 6.05549 16.6675 6.02914 16.6637H6.02537L5.6452 16.6186C5.66778 16.5132 5.67908 16.4003 5.67908 16.2873V10.1669C5.67908 10.005 5.65273 9.84693 5.60756 9.70013C5.67531 9.44793 5.86352 8.88708 6.30768 8.40903C7.99777 7.06901 9.65022 2.54831 9.72174 2.35257C9.75185 2.27353 9.75938 2.18695 9.74432 2.10038C9.68033 1.6788 9.70291 1.16311 9.79325 1.00878C9.99275 1.01255 10.531 1.06901 10.8547 1.51694C11.2387 2.04768 11.2236 2.99624 10.8096 4.25345C10.1772 6.16938 10.1245 7.17817 10.6251 7.62233C10.8736 7.84442 11.2048 7.85571 11.4457 7.76913C11.6753 7.71644 11.8936 7.67127 12.1007 7.63739C12.1157 7.63363 12.1345 7.62986 12.1496 7.6261C13.3052 7.3739 15.3754 7.21957 16.0944 7.87453C16.7042 8.43162 16.2713 9.16938 16.2224 9.24843C16.0831 9.45922 16.1245 9.734 16.3127 9.90339C16.3165 9.90715 16.7117 10.2798 16.7305 10.7804C16.7456 11.1154 16.5875 11.458 16.26 11.7967Z" fill="black"/>
                  </svg>
                </div>
                No
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
<!--    <div class="modal" v-if="feedbackModalShow" @mousedown.self="feedbackModalShow = false">
      <div class="modal-dialog modal-dialog-sm">
        <div class="modal-content">
          <div class="text-xl mb-05">Give us feedback</div>
          <div class="text-muted text-md mb-3">Some short description, why your feedback so important for us</div>
          <div class="feedback-options">
            <div class="mb-05">
              <label class="w-100 radio-wrapper" :class="{active: feedbackOption === '1'}">
                <input name="kidsAge" type="radio"  class="radio-input" value="1"
                       :checked="feedbackOption === '1'" @change="changeFeedback($event.target.value)">
                <span class="radio-check"></span>
                <span class="radio-label">Point 1</span>
              </label>
            </div>
            <div class="mb-05">
              <label class="w-100 radio-wrapper" :class="{active: feedbackOption === '2'}">
                <input name="kidsAge" type="radio"  class="radio-input" value="2"
                       :checked="feedbackOption === '2'" @change="changeFeedback($event.target.value)">
                <span class="radio-check"></span>
                <span class="radio-label">Point 2</span>
              </label>
            </div>
            <div class="mb-05">
              <label class="w-100 radio-wrapper" :class="{active: feedbackOption === '3'}">
                <input name="kidsAge" type="radio"  class="radio-input" value="3"
                       :checked="feedbackOption === '3'" @change="changeFeedback($event.target.value)">
                <span class="radio-check"></span>
                <span class="radio-label">Point 3</span>
              </label>
            </div>
            <div class="mb-05">
              <label class="w-100 radio-wrapper" :class="{active: feedbackOption === '4'}">
                <input name="kidsAge" type="radio"  class="radio-input" value="4"
                       :checked="feedbackOption === '4'" @change="changeFeedback($event.target.value)">
                <span class="radio-check"></span>
                <span class="radio-label">Point 4</span>
              </label>
            </div>
            <textarea class="form-control mt-2 mb-1" name="feedback_message" id="feedbackMessage" cols="30" rows="5" placeholder="Enter your feedback"></textarea>
            <div class="text-right">
              <button class="btn btn-transparent text-normal" @click="closeFeedback">Maybe later</button>
              <button class="btn btn-main" @click="sentFeedback">Send</button>
            </div>
          </div>
        </div>
      </div>
    </div>-->
  </div>
</template>

<script>

import {reportEvent} from "@/helpers/utils";

export default {
  name: 'Feedback',
  props: [''],
  data: function (){
    return {
      likeModalShow: false,
      userLike: false,
      userDisLike: false,
      feedbackshowcount: 0,
      extInstalledDate: null
    }
  },
  mounted () {
    this.extInstalledDate = localStorage.getItem('extInstalledDate') ? parseInt(localStorage.getItem('extInstalledDate')) : null
    const today = Date.now()
    this.feedbackshowcount = localStorage.getItem('showfeedback') ? parseInt(localStorage.getItem('showfeedback')) : null
    if ((this.extInstalledDate && !this.showFeedback && today - this.extInstalledDate > 300000) ||
        (this.extInstalledDate && this.showFeedback && today - this.extInstalledDate > 86400000 * 2)){
      this.likeModalShow = true
      reportEvent('ratePopupShowed')
    }
    if(this.feedbackshowcount > 2) {
      this.feedbackshowcount = false
      localStorage.removeItem('showfeedback')
      this.extInstalledDate = null
      localStorage.removeItem('extInstalledDate')
    }
  },
  methods: {
    closePopup (){
      reportEvent('userClosedRatePopup')
      if(this.feedbackshowcount){
        this.feedbackshowcount++
        localStorage.setItem('showfeedback', this.feedbackshowcount.toString())
        localStorage.setItem('extInstalledDate', Date.now().toString())
      } else if (this.extInstalledDate) {
        localStorage.setItem('showfeedback', '1')
        localStorage.setItem('extInstalledDate', Date.now().toString())
      }
      this.likeModalShow = false
    },
    userLiked (){
      reportEvent('userLikeExtFromRate')
      this.userLike = true
    },
    userDisliked (){
      reportEvent('userDislikeExtFromRate')
      this.userDisLike = true
    },
    openStore (){
      reportEvent('userOpenedChromeStoreFromRate')
      localStorage.removeItem('extInstalledDate')
      this.extInstalledDate = null
      this.likeModalShow = false
    },
    openFeedbackForm () {
      reportEvent('userOpenedFeedbackForm');
      this.likeModalShow = false
      window.open ('https://docs.google.com/forms/d/e/1FAIpQLSdUs6LnBbqQevHE-goqs3NRLze5ji8amEgB954VlTYHDPuh1g/viewform', '_blank', 'Feedback for Kidsmode')
      localStorage.removeItem('extInstalledDate')
      this.extInstalledDate = null
    }
  },
}

</script>

<style lang="scss" scoped>
@import "@/assets/styles/helpers";

  .feedback {
    &-image {
      position: absolute;
      left: 50%;
      top: 0;
      transform: translate(-50%, -50%);
      width: 130px;
    }
  }

  .radio-wrapper {
    line-height: 28px;
  }

  .modal {
    &-dialog {
      overflow: visible;
      text-align: center;
    }

    &-content {
      background: transparent;
      padding: 30px;

     &-small {
       padding: 60px 50px 20px;
     }
    }
  }


  .btn-rating {
    color: #1A1A1A;
    font-size: 16px;
    font-weight: 700;
    cursor: pointer;
    display: flex;
    align-items: center;
    transition: all 0.3s;

    &.-dislike {
      .btn-rating-icon {
        transform: rotate(-180deg);
      }
    }

    &-icon {
      width: 54px;
      height: 54px;
      border: 1px solid #C4C4C4;
      border-radius: 50%;
      margin-right: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  .btn-rating:hover {
    opacity: 0.7;
    text-decoration: none;
  }

</style>
